import { Outlet, useLocation } from 'react-router-dom';
import { TopBar } from '@/components/navigation/TopBar';
import { BottomNav } from '@/components/navigation/BottomNav';
import styles from './MobileLayout.module.css';

export function MobileLayout() {
  const { pathname } = useLocation();
  const hideTop =
    pathname === '/login' || pathname === '/loading' || pathname === '/profile';
  const hideBottom = pathname === '/login' || pathname === '/loading';
  const mutedNavSpacer = pathname === '/result';

  return (
    <div className={styles.shell}>
      {!hideTop ? <TopBar /> : null}
      <div className={styles.content}>
        <Outlet />
      </div>
      {!hideBottom ? (
        <>
          <div
            className={[styles.navspacer, mutedNavSpacer ? styles.navspacerMuted : '']
              .filter(Boolean)
              .join(' ')}
            aria-hidden
          />
          <BottomNav />
        </>
      ) : null}
    </div>
  );
}
